var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from "styled-components";
import { Lato, LatoBold } from "../../global/fonts";
var normal = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  font-size: 12px;\n  text-decoration: none;\n  :hover {\n    text-decoration: underline;\n  }\n"], ["\n  ", "\n  ", "\n  font-size: 12px;\n  text-decoration: none;\n  :hover {\n    text-decoration: underline;\n  }\n"])), LatoBold, function (_a) {
    var bold = _a.bold;
    return bold === false && Lato;
});
var body = "\n  text-decoration: underline;\n  :hover{\n    text-decoration: none;\n  }\n";
export default css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: left;\n  cursor: pointer;\n  ", "\n  ", "\n"], ["\n  text-align: left;\n  cursor: pointer;\n  ", "\n  ", "\n"])), function (_a) {
    var uppercase = _a.uppercase;
    return uppercase !== false && "text-transform: uppercase;";
}, function (_a) {
    var inBody = _a.inBody;
    return (inBody ? body : normal);
});
var templateObject_1, templateObject_2;
